import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { InterestFormComponent } from './components/interest-form/interest-form.component';
import { InterestService } from './services/interest.service';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { RecaptchaModule } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';
import { SpinnerDirective } from './directives/spinner.directive';
import { PositiveIntegerDirective } from './directives/positive-integer.directive';

@NgModule({
  declarations: [
    AppComponent,
    InterestFormComponent,
    SpinnerDirective,
    PositiveIntegerDirective
  ],
  imports: [
    BrowserModule,
    FormsModule,
    BrowserAnimationsModule,
    HttpClientModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    RouterModule.forRoot([{ path: '', component: InterestFormComponent }])
  ],
  providers: [InterestService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/linusvaltersson/AtomizeSource/clean_web/atomize-interest/src/app/app.module.ts